import { LucideIcon } from "lucide-react";

export const StatCard = ({
  icon: Icon,
  label,
  value,
  sublabel,
  color = "blue",
}: {
  icon: LucideIcon;
  label: string;
  value: string;
  sublabel?: string;
  color?: string;
}) => {
  const colorClasses: Record<string, string> = {
    blue: "border-blue-200 bg-blue-50 text-blue-600",
    green: "border-green-200 bg-green-50 text-green-600",
    red: "border-red-200 bg-red-50 text-red-600",
    orange: "border-orange-200 bg-orange-50 text-orange-600",
    purple: "border-purple-200 bg-purple-50 text-purple-600",
  };

  return (
    <div className={`p-4 rounded-lg border-2 ${colorClasses[color] || colorClasses.blue}`}>
      <div className="flex gap-3 items-center">
        <Icon className="w-8 h-8" />
        <div>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          <p className="text-sm font-medium">{label}</p>
          {sublabel && <p className="text-xs opacity-70">{sublabel}</p>}
        </div>
      </div>
    </div>
  );
};
